import type { LilliSettings } from "@/getSettings";

export default {
  // NOTE: privacy policy and tos may contain a string $langcode which will be replaced with the currently set language code of the user
  termsAndConditionsLink: "https://www.incontext.technology/impressum.html",
  privacyPolicyLink: "https://www.incontext.technology/datenschutz.html",
  headerlogo: "/img/logo.svg",
  loginImage: "/img/login-image.svg",
  showDetailsForQuiz: false,
  showDetailsForSurvey: false,
  showSeal: false,
  showCovidView: true,
  showCovidCertificatesToAdmin: true,
  showTestCenterView: true,
  showHardwareRestrictions: true,
  userStateShowDownload: true,
  publicSharedAccount: 437,
  title: "lilli e-learning",
  coursesUseImageSelector: true,
  courseProviderShareEnabled: true,
  additionalCertificateTextEnabled: true,
  registrationRequiresKey: true,
  hideContentManager: false,

  defaultSettings: {
    event: {
      selfRegistration: false,
      selfRegistrationAllUsersInAccount: false,
    },
    publication: {
      mandatory: false,
      generateCertificate: true,
    },
  },

  // possible values: phone, address, birthday, company, lastname, firstname, birthyear
  registrationRequiredDetails: {
    phone: { request: false, mandatory: false },
    address: { request: false, mandatory: false },
    firstname: { request: true, mandatory: true },
    lastname: { request: true, mandatory: true },
    birthday: { request: true, mandatory: true },
    company: { request: false, mandatory: false },
    emergencyContact: { request: true, mandatory: false },
  },
  customRegistrationFields: {
    fields: [
      {
        label: "company",
        type: "text",
        attributes: true,
        property: "nullableCompanyId",
        step: 0,
        nullable: true,
        nullLabel: "none",
        mandatory: false,
        regex: "^[0-9]{3}$",
        regexDescription: "company",
      },
      {
        label: "birthday",
        type: "date",
        attributes: true,
        property: "customDate",
        step: 0,
        mandatory: false,
      },
      {
        label: "birthyear",
        type: "year",
        attributes: true,
        property: "customYear",
        step: 0,
        mandatory: false,
      },
      {
        label: "address",
        type: "address",
        attributes: true,
        property: "address",
        step: 0,
        mandatory: false,
      },
    ],
  },
  customPublicRegistrations: {
    besucher: {
      email: { request: false, mandatory: false },
      username: { request: true, mandatory: true },
      firstname: { request: true, mandatory: true },
      lastname: { request: true, mandatory: true },
      birthday: { request: true, mandatory: true },
      emergencyContact: { request: true, mandatory: false },
    },
    kontraktor: {
      phone: { request: false, mandatory: false },
      address: { request: false, mandatory: false },
      firstname: { request: true, mandatory: true },
      lastname: { request: true, mandatory: true },
      birthday: { request: true, mandatory: true },
      company: { request: true, mandatory: true },
      emergencyContact: { request: true, mandatory: false },
    },
  },
  customEventDateFields: {
    customizationId: "lilli",
    fields: [
      {
        label: "test",
        property: "test",
        type: "test",
      },
    ],
  },
  qGateFields: [
    { id: "birthdate", type: "date", label: "birthday", mandatory: true },
    // {id: 'birthplace', type: 'string', label: 'birthplace', mandatory: true},
    // NOTE: nationalityWithNonEuVisa also adds the additional, optional fields socialSecurity and workPermit (if the user is not from the EU)
    {
      id: "nationality",
      type: "nationalityWithNonEuVisa",
      label: "nationality",
      mandatory: true,
    },
    // {id: 'address', type: 'string', label: 'address', mandatory: true},
    // {id: 'city', type: 'string', label: 'city', mandatory: true},
    // {id: 'zipCode', type: 'string', label: 'zipCode', mandatory: true},
    {
      id: "emergencyContact",
      type: "string",
      label: "emergencyContact",
      mandatory: false,
    },
    {
      id: "emergencyContactPhone",
      type: "string",
      label: "emergencyContactPhone",
      mandatory: false,
    },
    // {id: 'country', type: 'country', label: 'country', mandatory: true},
    {
      id: "car",
      type: "switchString",
      label: "driveInPermit",
      mandatory: false,
      settings: { subLabel: "carPlate", subId: "carPlate" },
    },
  ],
  emailAsUsername: true,
  supportedLanguages: [
    "de",
    "en",
    "fr",
    "bg",
    "cs",
    "el",
    "hr",
    "hu",
    "it",
    "lv",
    "pl",
    "pt",
    "ru",
    "ro",
    "es",
    "tr",
    "sr",
    "et",
    "nl",
    "ar",
  ],
  defaultLanguage: "de",
  registrationKeyMinimumLength: 4,

  // Language overrides allow to override specific values for translation files, this is an example to change 'Zertifikat' to 'Teilnahmebescheinigung'
  languageOverrides: {
    de: {
      courses: {
        certificate: "Teilnahmebescheinigung",
        certificates: "Teilnahmebescheinigungen",
        printCertificate: "Teilnahmebescheinigung drucken",
      },
      quizzes: {
        downloadCertificate:
          "Sie können jederzeit ihre Teilnahmebescheinigung unter Teilnahmebescheinigungen im Profil herunterladen und via E-Mail anfordern.",
      },
    },
  },
} satisfies LilliSettings;
